const autoNgTemplateLoaderTemplate1 = require('./edgeJobsDatatable.html');

import angular from 'angular';

angular.module('shbdeployer.edge').component('edgeJobsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
  },
});
